import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informasi Umum Sekolah")
], -1)
const _hoisted_6 = { class: "row mb-6" }
const _hoisted_7 = { class: "col-lg-6 fv-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nama Sekolah", -1)
const _hoisted_9 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "col-lg-6 fv-row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Initial", -1)
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "row mb-6" }
const _hoisted_17 = { class: "col-lg-6 fv-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Email", -1)
const _hoisted_19 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "col-lg-6 fv-row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nomor Telepon", -1)
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "row mb-6" }
const _hoisted_27 = { class: "col-lg-6 fv-row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Tipe Sekolah", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Tipe Sekolah", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", {
  value: "School",
  key: "School"
}, "Sekolah", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", {
  value: "Boarding_School",
  key: "Boarding_School"
}, " Boarding School ", -1)
const _hoisted_32 = { class: "fv-plugins-message-container" }
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 fv-row" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Alamat Sekolah")
], -1)
const _hoisted_36 = { class: "row mb-6" }
const _hoisted_37 = { class: "col-lg-6 fv-row" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Provinsi", -1)
const _hoisted_39 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = {
  key: 0,
  class: "col-lg-6 fv-row"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Kota/ Kabupaten", -1)
const _hoisted_44 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_45 = { class: "fv-help-block" }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = {
  key: 1,
  class: "col-lg-6 fv-row"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Kota/ Kabupaten", -1)
const _hoisted_49 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_50 = { class: "fv-help-block" }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { class: "row mb-6" }
const _hoisted_53 = {
  key: 0,
  class: "col-lg-6 fv-row"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Kecamatan", -1)
const _hoisted_55 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = {
  key: 1,
  class: "col-lg-6 fv-row"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Kecamatan", -1)
const _hoisted_60 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_61 = { class: "fv-help-block" }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { class: "col-lg-6 fv-row" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Alamat", -1)
const _hoisted_65 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_66 = { class: "fv-help-block" }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informasi Khusus")
], -1)
const _hoisted_69 = { class: "row mb-0" }
const _hoisted_70 = { class: "col-lg-6 fv-row" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Bank", -1)
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" Pilih Bank ")
const _hoisted_73 = { class: "fv-plugins-message-container" }
const _hoisted_74 = { class: "fv-help-block" }
const _hoisted_75 = { class: "col-lg-6 fv-row" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Area", -1)
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" Pilih Area ")
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" Pilih Area ")
const _hoisted_79 = { class: "row mb-0" }
const _hoisted_80 = { class: "col-lg-6 fv-row" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Cabang", -1)
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" Pilih Cabang ")
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" Pilih Cabang ")
const _hoisted_84 = { class: "col-lg-6 fv-row" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Funding", -1)
const _hoisted_86 = { class: "fv-plugins-message-container" }
const _hoisted_87 = { class: "fv-help-block" }
const _hoisted_88 = { class: "row mb-6" }
const _hoisted_89 = { class: "col-lg-6 fv-row" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nomor NPWP", -1)
const _hoisted_91 = { class: "fv-plugins-message-container" }
const _hoisted_92 = { class: "fv-help-block" }
const _hoisted_93 = { class: "col-lg-6 fv-row" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Input NPWP", -1)
const _hoisted_95 = { class: "fv-plugins-message-container" }
const _hoisted_96 = { class: "fv-help-block" }
const _hoisted_97 = { class: "row mb-6" }
const _hoisted_98 = { class: "col-lg-6 fv-row" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Status", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Status", -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("option", {
  value: "Leads",
  key: "Leads"
}, "Leads", -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("option", {
  value: "Waiting",
  key: "Waiting"
}, "Waiting", -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("option", {
  value: "Process",
  key: "Process"
}, "Process", -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("option", {
  value: "Pending",
  key: "Pending"
}, "Pending", -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("option", {
  value: "Closing",
  key: "Closing"
}, "Closing", -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("option", {
  value: "Cancel",
  key: "Cancel"
}, "Cancel", -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("option", {
  value: "Live",
  key: "Live"
}, "Live", -1)
const _hoisted_108 = { class: "fv-plugins-message-container" }
const _hoisted_109 = { class: "fv-help-block" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informasi PIC dan Sales")
], -1)
const _hoisted_111 = { class: "row mb-6" }
const _hoisted_112 = { class: "col-lg-6 fv-row" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nama PIC ", -1)
const _hoisted_114 = { class: "fv-plugins-message-container" }
const _hoisted_115 = { class: "fv-help-block" }
const _hoisted_116 = { class: "col-lg-6 fv-row" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Email PIC", -1)
const _hoisted_118 = { class: "fv-plugins-message-container" }
const _hoisted_119 = { class: "fv-help-block" }
const _hoisted_120 = { class: "row mb-6" }
const _hoisted_121 = { class: "col-lg-6 fv-row" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nomor Telepon PIC", -1)
const _hoisted_123 = { class: "fv-plugins-message-container" }
const _hoisted_124 = { class: "fv-help-block" }
const _hoisted_125 = { class: "col-lg-6 fv-row" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Sales Area", -1)
const _hoisted_127 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Sales Area", -1)
const _hoisted_128 = ["label", "value"]
const _hoisted_129 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "fv-help-block" }, " warna hijau sebagai prioritas sales area ", -1)
const _hoisted_131 = [
  _hoisted_130
]
const _hoisted_132 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informasi Tambahan")
], -1)
const _hoisted_133 = { class: "row mb-6" }
const _hoisted_134 = { class: "col-lg-6 fv-row" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Catatan", -1)
const _hoisted_136 = { class: "fv-plugins-message-container" }
const _hoisted_137 = { class: "fv-help-block" }
const _hoisted_138 = { class: "col-lg-6 fv-row" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Target Live", -1)
const _hoisted_140 = { class: "fv-plugins-message-container" }
const _hoisted_141 = { class: "fv-help-block" }
const _hoisted_142 = { class: "row mb-6" }
const _hoisted_143 = { class: "col-lg-6 fv-row" }
const _hoisted_144 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Referensi Dari", -1)
const _hoisted_145 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Referensi", -1)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("option", {
  value: "Media Sosial",
  key: "Media Sosial"
}, " Media Sosial ", -1)
const _hoisted_147 = /*#__PURE__*/_createElementVNode("option", {
  value: "Bank",
  key: "Bank"
}, "Bank", -1)
const _hoisted_148 = /*#__PURE__*/_createElementVNode("option", {
  value: "Webinar",
  key: "Webinar"
}, "Webinar", -1)
const _hoisted_149 = /*#__PURE__*/_createElementVNode("option", {
  value: "Iklan",
  key: "Iklan"
}, "Iklan", -1)
const _hoisted_150 = /*#__PURE__*/_createElementVNode("option", {
  value: "Relasi",
  key: "Relasi"
}, "Relasi", -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("option", {
  value: "Lainnya",
  key: "Lainnya"
}, "Lainnya", -1)
const _hoisted_152 = { class: "fv-plugins-message-container" }
const _hoisted_153 = { class: "fv-help-block" }
const _hoisted_154 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_155 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_156 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1)
const _hoisted_157 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_158 = [
  _hoisted_156,
  _hoisted_157
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          novalidate: "novalidate",
          onSubmit: _cache[31] || (_cache[31] = ($event: any) => (_ctx.saveChanges1()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "name",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nama Sekolah",
                    modelValue: _ctx.tambahSekolah.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tambahSekolah.name) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.tambahSekolah.name == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.items.errorschoolName), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "initial",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Initial",
                    modelValue: _ctx.tambahSekolah.initial,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tambahSekolah.initial) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_ErrorMessage, { name: "initial" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "email",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Email",
                    modelValue: _ctx.tambahSekolah.email,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tambahSekolah.email) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.tambahSekolah.email != '' && _ctx.items.erroremail != '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.items.erroremail), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21))
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(_component_Field, {
                    type: "number",
                    name: "phone",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nomor Telepon",
                    modelValue: _ctx.tambahSekolah.phone,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tambahSekolah.phone) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_ErrorMessage, { name: "phone" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createVNode(_component_Field, {
                    as: "select",
                    class: "form-select form-select-lg fw-bold",
                    name: "schoolType",
                    autocomplete: "off",
                    modelValue: _ctx.tambahSekolah.schoolType,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tambahSekolah.schoolType) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_29,
                      _hoisted_30,
                      _hoisted_31
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_ErrorMessage, { name: "schoolType" })
                    ])
                  ])
                ]),
                _hoisted_34
              ]),
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createVNode(_component_Multiselect, {
                    name: "province",
                    modelValue: _ctx.tambahSekolah.address.province,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tambahSekolah.address.province) = $event)),
                    placeholder: "Pilih Provinsi",
                    mode: "single",
                    "create-option": false,
                    options: _ctx.items.provinsiOptions,
                    searchable: true,
                    label: "name",
                    "track-by": "name",
                    "value-prop": "name",
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.pilihProv($event)))
                  }, null, 8, ["modelValue", "options"]),
                  (_ctx.tambahSekolah.address.province === '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.items.errorprovince), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_41))
                ]),
                (_ctx.items.prov === '1')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _hoisted_43,
                      _createVNode(_component_Multiselect, {
                        name: "city",
                        modelValue: _ctx.city,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.city) = $event)),
                        placeholder: "Pilih Kota/Kabupaten",
                        mode: "single",
                        "create-option": false,
                        options: _ctx.items.kabupatenOptions,
                        searchable: true,
                        label: "name",
                        "track-by": "name",
                        "value-prop": "name",
                        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.pilihKab($event)))
                      }, null, 8, ["modelValue", "options"]),
                      (_ctx.tambahSekolah.address.city == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.items.errorcity), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_46))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _hoisted_48,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "detail",
                        class: "form-control form-control-lg",
                        placeholder: "Pilih Provinsi Terlebih Dahulu",
                        disabled: ""
                      }),
                      (_ctx.tambahSekolah.address.city == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.items.errorcity), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_51))
                    ]))
              ]),
              _createElementVNode("div", _hoisted_52, [
                (_ctx.items.kab === '1')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _hoisted_54,
                      _createVNode(_component_Multiselect, {
                        name: "regency",
                        modelValue: _ctx.regency,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.regency) = $event)),
                        placeholder: "Pilih Kecamatan",
                        mode: "single",
                        "create-option": false,
                        options: _ctx.items.kecamatanOptions,
                        searchable: true,
                        label: "name",
                        "track-by": "name",
                        "value-prop": "name",
                        onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.pilihKec($event)))
                      }, null, 8, ["modelValue", "options"]),
                      (_ctx.tambahSekolah.address.regency == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.items.errorregency), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_57))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      _hoisted_59,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "detail",
                        class: "form-control form-control-lg",
                        placeholder: "Pilih Kabupaten Terlebih Dahulu",
                        disabled: ""
                      }),
                      (_ctx.tambahSekolah.address.regency == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.items.errorregency), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_62))
                    ])),
                _createElementVNode("div", _hoisted_63, [
                  _hoisted_64,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "detail",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Alamat",
                    modelValue: _ctx.tambahSekolah.address.detail,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.tambahSekolah.address.detail) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.tambahSekolah.address.detail == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.items.errordetail), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_67))
                ])
              ]),
              _hoisted_68,
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _hoisted_71,
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changeBank(_ctx.items.listBank.length))),
                        modelValue: _ctx.tambahSekolah.bankData,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.tambahSekolah.bankData) = $event)),
                        multiple: "",
                        filterable: "",
                        "default-first-option": "",
                        placeholder: "Pilih Bank"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "",
                            value: "",
                            disabled: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_72
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listBank, (option) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: option._id,
                              label: option.name,
                              value: option._id,
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeListArea(_ctx.tambahSekolah.bankData[0])))
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                      _createVNode(_component_ErrorMessage, { name: "bankData" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _hoisted_76,
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      (_ctx.tambahSekolah.bankData.length !== 0)
                        ? (_openBlock(), _createBlock(_component_el_select, {
                            key: 0,
                            modelValue: _ctx.tambahSekolah.bankAreaId,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.tambahSekolah.bankAreaId) = $event)),
                            filterable: "",
                            "allow-create": "",
                            "default-first-option": "",
                            placeholder: "Pilih Area"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "",
                                value: "",
                                disabled: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_77
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listArea, (option) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: option.areaId,
                                  label: option.areaName,
                                  onClick: ($event: any) => (_ctx.changeListBranch(option._id, option.areaId)),
                                  value: option.areaId
                                }, null, 8, ["label", "onClick", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                        : (_openBlock(), _createBlock(_component_el_select, {
                            key: 1,
                            disabled: "",
                            modelValue: _ctx.tambahSekolah.bankAreaId,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.tambahSekolah.bankAreaId) = $event)),
                            filterable: "",
                            "allow-create": "",
                            "default-first-option": "",
                            placeholder: "Pilih Area"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "",
                                value: "",
                                disabled: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_78
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listArea, (option) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: option.areaId,
                                  label: option.areaName,
                                  onClick: ($event: any) => (_ctx.changeListBranch(option._id, option.areaId)),
                                  value: option.areaId
                                }, null, 8, ["label", "onClick", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _hoisted_81,
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      (
                    _ctx.tambahSekolah.bankAreaId == null ||
                    _ctx.tambahSekolah.bankAreaId == ''
                  )
                        ? (_openBlock(), _createBlock(_component_el_select, {
                            key: 0,
                            disabled: "",
                            modelValue: _ctx.tambahSekolah.bankBranchId,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.tambahSekolah.bankBranchId) = $event)),
                            filterable: "",
                            "allow-create": "",
                            "default-first-option": "",
                            placeholder: "Pilih Cabang"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "",
                                value: "",
                                disabled: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_82
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listBranch, (option) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: option._id,
                                  label: option.branchName,
                                  value: option.branchId
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                        : (_openBlock(), _createBlock(_component_el_select, {
                            key: 1,
                            modelValue: _ctx.tambahSekolah.bankBranchId,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.tambahSekolah.bankBranchId) = $event)),
                            filterable: "",
                            "allow-create": "",
                            "default-first-option": "",
                            placeholder: "Pilih Cabang"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "",
                                value: "",
                                disabled: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_83
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listBranch, (option) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: option._id,
                                  label: option.branchName,
                                  value: option.branchId
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_84, [
                  _hoisted_85,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "fundingName",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nama Funding",
                    modelValue: _ctx.tambahSekolah.fundingName,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.tambahSekolah.fundingName) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, [
                      _createVNode(_component_ErrorMessage, { name: "fundingId" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _hoisted_90,
                  _createVNode(_component_Field, {
                    type: "number",
                    name: "number",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nomor NPWP",
                    modelValue: _ctx.tambahSekolah.npwp.number,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.tambahSekolah.npwp.number) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("div", _hoisted_92, [
                      _createVNode(_component_ErrorMessage, { name: "number" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_93, [
                  _hoisted_94,
                  _createElementVNode("input", {
                    class: "form-control form-control-lg",
                    name: "file",
                    type: "file",
                    onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleFileUpload($event))),
                    placeholder: "Upload File NPWP",
                    accept: "image/*"
                  }, null, 32),
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("div", _hoisted_96, [
                      _createVNode(_component_ErrorMessage, { name: "imageUrl" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_97, [
                _createElementVNode("div", _hoisted_98, [
                  _hoisted_99,
                  _createVNode(_component_Field, {
                    as: "select",
                    class: "form-select form-select-lg fw-bold",
                    name: "status",
                    autocomplete: "off",
                    modelValue: _ctx.tambahSekolah.status,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.tambahSekolah.status) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_100,
                      _hoisted_101,
                      _hoisted_102,
                      _hoisted_103,
                      _hoisted_104,
                      _hoisted_105,
                      _hoisted_106,
                      _hoisted_107
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_108, [
                    _createElementVNode("div", _hoisted_109, [
                      _createVNode(_component_ErrorMessage, { name: "status" })
                    ])
                  ])
                ])
              ]),
              _hoisted_110,
              _createElementVNode("div", _hoisted_111, [
                _createElementVNode("div", _hoisted_112, [
                  _hoisted_113,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "picName",
                    class: "form-control form-control-lg",
                    placeholder: "Isi PIC Sekolah",
                    modelValue: _ctx.tambahSekolah.picName,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.tambahSekolah.picName) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("div", _hoisted_115, [
                      _createVNode(_component_ErrorMessage, { name: "picName" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_116, [
                  _hoisted_117,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "picEmail",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Email PIC",
                    modelValue: _ctx.tambahSekolah.picEmail,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.tambahSekolah.picEmail) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_118, [
                    _createElementVNode("div", _hoisted_119, [
                      _createVNode(_component_ErrorMessage, { name: "picEmail" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_120, [
                _createElementVNode("div", _hoisted_121, [
                  _hoisted_122,
                  _createVNode(_component_Field, {
                    type: "number",
                    name: "picPhone",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nomor Telepon PIC",
                    modelValue: _ctx.tambahSekolah.picPhone,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.tambahSekolah.picPhone) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_123, [
                    _createElementVNode("div", _hoisted_124, [
                      _createVNode(_component_ErrorMessage, { name: "picPhone" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_125, [
                  _hoisted_126,
                  _createVNode(_component_Field, {
                    as: "select",
                    class: "form-select form-select-lg fw-bold",
                    name: "salesArea",
                    autocomplete: "off",
                    modelValue: _ctx.tambahSekolah.salesArea,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.tambahSekolah.salesArea) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_127,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.user_sales_area, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option._id,
                          label: 
                    option.name === true ? option.name + ' *' : option.name
                  ,
                          value: option._id,
                          style: _normalizeStyle(
                    option.regions === true
                      ? { color: '#00A86B' }
                      : { color: '#000000' }
                  )
                        }, null, 12, _hoisted_128))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.tambahSekolah.address.province)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_129, _hoisted_131))
                    : _createCommentVNode("", true)
                ])
              ]),
              _hoisted_132,
              _createElementVNode("div", _hoisted_133, [
                _createElementVNode("div", _hoisted_134, [
                  _hoisted_135,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "note",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Catatan",
                    modelValue: _ctx.tambahSekolah.note,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.tambahSekolah.note) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_136, [
                    _createElementVNode("div", _hoisted_137, [
                      _createVNode(_component_ErrorMessage, { name: "note" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_138, [
                  _hoisted_139,
                  _createVNode(_component_Field, {
                    type: "date",
                    name: "targetLive",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Target Live",
                    modelValue: _ctx.tambahSekolah.targetLive,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.tambahSekolah.targetLive) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_140, [
                    _createElementVNode("div", _hoisted_141, [
                      _createVNode(_component_ErrorMessage, { name: "targetLive" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_142, [
                _createElementVNode("div", _hoisted_143, [
                  _hoisted_144,
                  _createVNode(_component_Field, {
                    as: "select",
                    class: "form-select form-select-lg fw-bold",
                    name: "referenceFrom",
                    autocomplete: "off",
                    modelValue: _ctx.tambahSekolah.referenceFrom,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.tambahSekolah.referenceFrom) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_145,
                      _hoisted_146,
                      _hoisted_147,
                      _hoisted_148,
                      _hoisted_149,
                      _hoisted_150,
                      _hoisted_151
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_152, [
                    _createElementVNode("div", _hoisted_153, [
                      _createVNode(_component_ErrorMessage, { name: "status" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_154, [
              _createElementVNode("button", {
                class: "btn btn-danger me-3",
                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.$router.push('/superadmin/sekolah')))
              }, " Batal "),
              _createElementVNode("button", _hoisted_155, _hoisted_158, 512)
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}